import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdowns/DashboardDimensionFilterDropdown'

// Control values come from the controls dim, which the risk metrics stamp with the controls linked to
// each risk — the only place this filter's values exist.
export const DashboardControlFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null => {
  if (dashboardContext === undefined || dashboardName === undefined) {
    return null
  }

  return (
    <DashboardDimensionFilterDropdown
      isNested={isNested}
      filterParam={FilterParam.DASHBOARD_CONTROL}
      filterName={FilterName.DASHBOARD_CONTROL}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="controls"
      // Points carrying no controls dim land in this bucket.
      undefinedString={NONE_NAME}
    />
  )
}
